module.exports = __webpack_public_path__ + "static/media/intro_3.8d5c9ba5.png";